import { inject, Injectable } from '@angular/core';

import { CompanyVerificationDialogComponent } from '@core/tellent-company-verification-smart-ui';
import { TELLENT_NOT_AUTHORIZED, TELLENT_SUITE_ENABLED } from '@core/tellent-types';
import { DialogService, DialogWidth } from '@core/user-interface-legacy';

import { SpamVerificationDialogComponent } from '../containers/spam-verification-dialog/spam-verification-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class SpamVerificationDialogService {
  private dialogService = inject(DialogService);
  private tsEnabledButUnauthorized = inject(TELLENT_NOT_AUTHORIZED);
  private tsEnabled = inject(TELLENT_SUITE_ENABLED);

  public open() {
    return !this.tsEnabled || this.tsEnabledButUnauthorized
      ? this.dialogService.openCustom(
          SpamVerificationDialogComponent,
          { width: DialogWidth.SmallXX },
          {},
        )
      : this.dialogService.openCustom(
          CompanyVerificationDialogComponent,
          { width: DialogWidth.SmallXX },
          {},
        );
  }
}
